import { render, staticRenderFns } from "./antecedent-medical.vue?vue&type=template&id=38012bd1&"
import script from "./antecedent-medical.vue?vue&type=script&lang=js&"
export * from "./antecedent-medical.vue?vue&type=script&lang=js&"
import style0 from "./antecedent-medical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports